import { ChartCardWithWidget } from 'src/components/overview/ChartCard'
import { CheckWidget } from 'src/components/overview/charts/common/CheckWidget'
import AddressPrefillRate from 'src/components/overview/charts/ConversionSection/AddressPrefillRate'
import AutoLoggedInSessions from 'src/components/overview/charts/ConversionSection/AutoLoggedInSessions'
import ComparisonRate from 'src/components/overview/charts/ConversionSection/ComparisonRate'
import ConversionRateComparison from 'src/components/overview/charts/ConversionSection/ConversionRateComparison'
import ConversionRateMultipleSeries from 'src/components/overview/charts/ConversionSection/ConversionRateMultipleSeries'
import FunnelChart from 'src/components/overview/charts/ConversionSection/FunnelChart'
import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'

import AbandonedCheckoutsRecoveryTable from 'src/components/overview/charts/OrdersSection/AbandonedCheckoutsRecoveryTable'
import ExitCheckoutSurvey from '../charts/ConversionSection/ExitCheckoutSurvey'

const ConversionsSection = () => {
  return (
    <div>
      {/* Charts */}
      <div className='space-y-6'>
        {/* Single Series Line Chart */}
        <div className='grid grid-cols-2 gap-4'>
          {/* Comparison Line Chart */}
          <CheckWidget widgetId={WidgetId.conversion_rate}>
            <ChartCardWithWidget widgetSection={WidgetSections.conversion} widgetId={WidgetId.conversion_rate} >
              <ComparisonRate />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.conversion_funnel}>
            <ChartCardWithWidget widgetSection={WidgetSections.conversion} widgetId={WidgetId.conversion_funnel}>
              <FunnelChart />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.conversion_address_prefilled_rate}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.conversion}
              widgetId={WidgetId.conversion_address_prefilled_rate}
            >
              <AddressPrefillRate />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.conversion_rate_comparison}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.conversion}
              widgetId={WidgetId.conversion_rate_comparison}
            >
              <ConversionRateComparison />
            </ChartCardWithWidget>
          </CheckWidget>
          <CheckWidget widgetId={WidgetId.conversion_auto_logged_in_sessions}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.conversion}
              widgetId={WidgetId.conversion_auto_logged_in_sessions}
            >
              <AutoLoggedInSessions />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.conversion_rate_timescale}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.conversion}
              widgetId={WidgetId.conversion_rate_timescale}
            >
              <ConversionRateMultipleSeries />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_abandoned_checkout_recovery}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.orders}
              widgetId={WidgetId.orders_abandoned_checkout_recovery}
            >
              <AbandonedCheckoutsRecoveryTable />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.exit_checkout_survey}>
            <ChartCardWithWidget widgetSection={WidgetSections.conversion} widgetId={WidgetId.exit_checkout_survey}>
              <ExitCheckoutSurvey />
            </ChartCardWithWidget>
          </CheckWidget>
        </div>
      </div>
    </div>
  )
}

export default ConversionsSection
